import { ECampaignType } from './campaigns.model';

export interface IDiscountPayload {
  name: string;
  setup_id?: number;
  percentage?: boolean;
  discount: number;
  expire_at?: string;
  max_redemptions?: number;
  duration?: EDiscountDuration;
  months?: number;
  user_cost?: number;
  commission?: number;
  products: number[];
  contents?: IDiscountCampaignSet[];
  access?: string;
  trial_days?: number;
}

export interface IDiscountCampaignSet {
  id: number;
  content_group_id: number;
  content_code?: string;
  campaign_name: string;
  campaign_type: ECampaignType;
  frequency: number;
  contact_group: string;
}

export enum EDiscountDuration {
  FOREVER = 'forever',
  ONCE = 'once',
  MULTIPLE_MONTHS = 'repeating'
}

export enum EDiscountOptionType {
  COST_AND_SET_UP,
  COST
}

export enum EDiscountType {
  RECURRING = 'recurring',
  ONE_TIME = 'one_time',
  INTERNAL = 'internal',
}

export interface IPlanProduct {
  id: number;
  name: string;
  description: string;
  setup_fee: string;
  recurring_Free: string;
  contacts_limit: number;
  send_limit: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  plan_id: number;
  fee: string;
  vsm: boolean;
  trial_days: number;
  period: string;
}

export interface IDiscountProduct {
  active: boolean;
  contacts_limit: number;
  created_at: string;
  deleted_at: string | null;
  description: string;
  id: number;
  name: string;
  provider_id: string;
  send_limit: number;
  updated_at: string;
  vsm: boolean;
}

export interface ISetupDiscount {
  additional_user_price: any;
  created_at: string;
  deleted_at: string;
  description: string;
  discount: string;
  expire_at: string;
  franchise_commission: any;
  id: number;
  is_internal: boolean;
  is_setup: boolean;
  max_redemptions: any;
  name: string;
  percentage: boolean;
  provider_id: string;
  setup_discount_id: number;
  subscription_duration: string;
  subscription_repeat: any;
  total_redemptions: number;
  updated_at: string;
}

export interface IDiscount {
  setup_discount_percentage?: string;
  access: any;
  contents: any[];
  created_at: string;
  deleted_at: string | null;
  description: string | null;
  discount: string;
  expire_at: string;
  franchise_commission: any;
  id: number;
  max_redemptions: any;
  name: string;
  percentage: number;
  products: IDiscountProduct[],
  subscription_duration: string;
  subscription_repeat: any;
  total_redemptions: number;
  updated_at: string;
  valid: boolean;
  setup_discount: ISetupDiscount;
  setup_discount_id?: number;
  additional_user_price?: string;
  trial_days_override?: number;
}
